import { SET_ADMIN } from "./action";

const initialState = {
  admin: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADMIN:
      return {
        ...state,
        admin: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
